import { ErrorResolutionActions } from '../../../../app/common/errorResolution/errorResolutionActions';
import ErrorRedirectService from '../../../../routes/error/errorRedirect.service';
import { NotificationsActions } from '../../../../app/common/notifications/notificationsActions';
import { TranslationHelpers } from '../../../../i18n/translationHelpers';
import { rakutenServicesActionTypes } from './rakutenServices.constants';
import { getALinksAndNLStatus, updateNletterStatus } from './rakutenServices.services';
import { deleteAccountSvc } from '../../sharedAPI.services';
import { ErrorResolutionTypes } from '../../../../app/common/errorResolution/errorResolution';
import { NOTIFICATIONS } from '../../../../app/common/constants/styles';
import { NotificationType } from '../../../../app/common/notifications/notificationType.enum';

export const rakutenServicesActions = {
    updateNewsletterStatus,
    startDeleteAccount,
    cancelMembership,
    loadServicesConfig,
    getAgreementsLinksAndNewsletterStatus,
};

function loadServicesConfig() {
    return async (dispatch, getState) => {
        dispatch(request());
        try {
            const servicesConfig = await (
                await fetch(`${process.env.PUBLIC_URL}/config/servicesConfig.json`)
            ).json();
            dispatch(success(servicesConfig));
        } catch (error) {
            dispatch(ErrorResolutionActions.processErrorResolution(error));
            dispatch(failure(error));
        }
    };

    function request() {
        return { type: rakutenServicesActionTypes.LOAD_SERVICES_CONFIG_REQUEST };
    }

    function success(servicesConfig) {
        return {
            type: rakutenServicesActionTypes.LOAD_SERVICES_CONFIG_SUCCESS,
            servicesConfig,
        };
    }

    function failure(error) {
        return { type: rakutenServicesActionTypes.LOAD_SERVICES_CONFIG_FAILURE, error };
    }
}

function updateNewsletterStatus(data) {
    return (dispatch, getState) => {
        const { serviceUuid } = data;
        dispatch(request(serviceUuid));

        updateNletterStatus(data)
            .then((nlStatus) => {
                const { nlSubscription } = nlStatus;

                dispatch(success({ nlSubscription, serviceUuid }, getState().app.clientConfig));
                dispatch(
                    NotificationsActions.showSuccess(
                        TranslationHelpers.getFormattedMessage(
                            'notifications.account.subscription.update.success',
                        ),
                    ),
                );
            })
            .catch((error) => {
                dispatch(ErrorResolutionActions.processErrorResolution(error));
                dispatch(failure(serviceUuid, error));
            });
    };

    function request(serviceUuid) {
        return { type: rakutenServicesActionTypes.UPDATE_NEWSLETTER_REQUEST, serviceUuid };
    }

    function success(nlStatus, clientConfig) {
        const ratMeta = {
            rat: {},
        };

        if (nlStatus.nlSubscription) {
            ratMeta.rat.cvData = {
                mailmag_subscribe: 1,
            };
        }
        return {
            type: rakutenServicesActionTypes.UPDATE_NEWSLETTER_SUCCESS,
            nlStatus,
            clientConfig,
            meta: ratMeta,
        };
    }

    function failure(serviceUuid, error) {
        return {
            type: rakutenServicesActionTypes.UPDATE_NEWSLETTER_FAILURE,
            payload: { serviceUuid, error },
        };
    }
}

function startDeleteAccount() {
    return (dispatch, getState) => {
        const { clientConfig } = getState().app;
        dispatch(deleteAccountClick(clientConfig));
    };

    function deleteAccountClick(clientConfig) {
        return {
            type: rakutenServicesActionTypes.CANCEL_MEMBERSHIP_START,
            clientConfig,
            meta: {
                rat: {},
            },
        };
    }
}

function cancelMembership(user, password) {
    return (dispatch, getState) => {
        const data = {
            clientId: getState().app.clientConfig.clientId,
            currentPassword: password,
        };

        dispatch(request(user));
        deleteAccountSvc(data, password)
            .then(() => {
                const clientConfig = getState().app.clientConfig;

                dispatch(
                    ErrorResolutionActions.processErrorResolution({
                        errorMessageId: 'notifications.account.deleted',
                        type: ErrorResolutionTypes.ERROR_CODE_MESSAGE,
                    }),
                );

                setInterval(() => {
                    ErrorRedirectService.takeToLogout();
                    dispatch(success(clientConfig));
                }, NOTIFICATIONS[NotificationType.Error].expiry);
            })
            .catch((error) => {
                dispatch(
                    ErrorResolutionActions.processErrorResolution(
                        error,
                        'notifications.account.password.update.failure',
                    ),
                );
                dispatch(failure(error));
            });
    };

    function request(member) {
        return { type: rakutenServicesActionTypes.CANCEL_MEMBERSHIP_REQUEST, member };
    }

    function success(clientConfig) {
        return {
            type: rakutenServicesActionTypes.CANCEL_MEMBERSHIP_SUCCESS,
            clientConfig,
            meta: {
                rat: {},
            },
        };
    }

    function failure(error) {
        return { type: rakutenServicesActionTypes.CANCEL_MEMBERSHIP_FAILURE, error };
    }
}

function getAgreementsLinksAndNewsletterStatus() {
    return (dispatch, getState) => {
        dispatch(request());

        getALinksAndNLStatus()
            .then((agreementsAndNewsletterStatuses) => {
                dispatch(success(agreementsAndNewsletterStatuses));
            })
            .catch((error) => {
                dispatch(ErrorResolutionActions.processErrorResolution(error));
                dispatch(failure(error));
            });
    };

    function request() {
        return { type: rakutenServicesActionTypes.GET_AL_AND_NL_REQUEST };
    }

    function success(agreementsAndNewsletterStatuses) {
        return {
            type: rakutenServicesActionTypes.GET_AL_AND_NL_SUCCESS,
            agreementsAndNewsletterStatuses,
        };
    }

    function failure(error) {
        return { type: rakutenServicesActionTypes.GET_AL_AND_NL_FAILURE, error };
    }
}
